import { render, staticRenderFns } from "./params-setting.vue?vue&type=template&id=54474db8&scoped=true&"
import script from "./params-setting.vue?vue&type=script&lang=js&"
export * from "./params-setting.vue?vue&type=script&lang=js&"
import style0 from "./params-setting.vue?vue&type=style&index=0&id=54474db8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54474db8",
  null
  
)

export default component.exports